import convict from 'convict';
import { ClientConfig } from './ClientConfig';

export type ClientConfigSchema = convict.Schema<ClientConfig>;

export const clientConfigSchema: ClientConfigSchema = {
    app: {
        url: {
            format: 'url',
            default: null,
            env: 'NEXT_PUBLIC_APP_URL',
        },
        starUrl: {
            format: 'url',
            default: null,
            env: 'NEXT_PUBLIC_STAR_APP_URL',
        },
        env: {
            format: String,
            default: null,
            env: 'NEXT_PUBLIC_ENV',
        },
        growthBookKey: {
            format: String,
            default: null,
            env: 'NEXT_PUBLIC_GROWTH_BOOK_KEY',
        },
        quoteExpiryDays: {
            format: Number,
            default: null,
            env: 'NEXT_PUBLIC_QUOTE_EXPIRY_DAYS',
        },
        versionInfo: {
            commit: {
                format: String,
                default: null,
                env: 'NEXT_PUBLIC_COMMIT_HASH',
            },
            build: {
                format: Number,
                default: null,
                env: 'NEXT_PUBLIC_BUILD_NO',
            },
            user: {
                format: String,
                default: null,
                env: 'NEXT_PUBLIC_BUILD_USER',
            },
            host: {
                format: String,
                default: null,
                env: 'NEXT_PUBLIC_BUILD_HOST',
            },
            date: {
                format: String,
                default: null,
                env: 'NEXT_PUBLIC_BUILD_DATE',
            },
            timestamp: {
                format: Number,
                default: null,
                env: 'NEXT_PUBLIC_BUILD_TIMESTAMP',
            },
        },
        blockEditHolidaySurchargeBooking: {
            format: Boolean,
            default: false,
            env: 'NEXT_PUBLIC_BLOCK_EDIT_HOLIDAY_SURCHARGE_BOOKING',
        },
        vffEligibleHoursBeforeDropOff: {
            format: Number,
            default: 24,
            env: 'NEXT_PUBLIC_VFF_ELIGIBLE_HOURS_BEFORE_DROP_OFF',
        },
    },
    website: {
        baseUrl: {
            format: 'url',
            default: 'https://www.jucy.com',
            env: 'NEXT_PUBLIC_WEBSITE_BASE',
        },
    },
    starWebsite: {
        baseUrl: {
            format: 'url',
            default: 'https://www.starrv.com',
            env: 'NEXT_PUBLIC_WEBSITE_STAR_BASE',
        },
    },
    au: {
        translatorUrl: {
            format: 'url',
            default: null,
            env: 'NEXT_PUBLIC_AU_TRANSLATOR_URL',
        },
    },
    nz: {
        translatorUrl: {
            format: 'url',
            default: null,
            env: 'NEXT_PUBLIC_NZ_TRANSLATOR_URL',
        },
    },
    firebase: {
        apiKey: {
            format: String,
            default: null,
            env: 'NEXT_PUBLIC_FIREBASE_API_KEY',
        },
        authDomain: {
            format: String,
            default: null,
            env: 'NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN',
        },
        databaseURL: {
            format: String,
            default: null,
            env: 'NEXT_PUBLIC_FIREBASE_DATABASE_URL',
        },
        projectId: {
            format: String,
            default: null,
            env: 'NEXT_PUBLIC_FIREBASE_PROJECT_ID',
        },
        storageBucket: {
            format: String,
            default: null,
            env: 'NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET',
        },
        messagingSenderId: {
            format: String,
            default: null,
            env: 'NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID',
        },
        appId: {
            format: String,
            default: null,
            env: 'NEXT_PUBLIC_FIREBASE_APP_ID',
        },
        measurementId: {
            format: String,
            default: null,
            env: 'NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID',
        },
    },
    rentalsApi: {
        baseUrl: {
            format: 'url',
            default: null,
            env: 'NEXT_PUBLIC_RENTALS_API_BASE_URL',
        },
    },
    maintenance: {
        showMessage: {
            format: Boolean,
            default: false,
            env: 'NEXT_PUBLIC_MAINTENANCE_SHOW_MESSAGE',
        },
    },
    googleMaps: {
        apiKey: {
            format: String,
            default: null,
            env: 'NEXT_PUBLIC_GMAPS_API_KEY',
        },
    },
    hotjar: {
        id: {
            format: Number,
            default: null,
            env: 'NEXT_PUBLIC_HOTJAR_ID',
            nullable: true,
        },
        sv: {
            format: Number,
            default: null,
            env: ' NEXT_PUBLIC_HOTJAR_SV',
            nullable: true,
        },
    },
    log: {
        level: {
            root: {
                format: ['error', 'warn', 'info', 'verbose', 'debug', 'silly'],
                default: 'info',
                env: 'APP_LOG_LEVEL',
            },
        },
        jsonEnabled: {
            format: Boolean,
            default: false,
            env: 'APP_LOG_JSON_ENABLED',
        },
        traceEnabled: {
            format: Boolean,
            default: false,
            env: 'APP_LOG_TRACE_ENABLED',
        },
    },
    terms26: {
        payLater: {
            minDaysBeforePickupFallback: {
                format: Number,
                default: 7,
                env: 'NEXT_PUBLIC_TERMS26_PAY_LATER_MIN_DAYS_BEFORE_PICKUP_FALLBACK',
            },
        },
    },
};
